import pauseService from '../PauseService';

const pauseStateHandler = {
    handle(body) {
        if (!body) {
            return;
        }

        if (body.RUN_RESUMED !== undefined) {
            pauseService.resume();
        } else if (body.RUN_PAUSED !== undefined) {
            pauseService.pause(body.RUN_PAUSED);
        }
    },
};

export default pauseStateHandler;
